module.exports = __webpack_public_path__ + "img/red.14dd3d31.webp";